import React, { useCallback, useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { useDOM } from '../hooks/useDOM';
/**
 * Render single-line text, and omit the text and show a tooltip only if the text is
 * too long to show in a single line.
 */
export default ({ component = 'div', title, children, onMounted, ...otherProps }) => {
    const [isOverflow, setIsOverflow] = useState(false);
    const recalculateWidth = useCallback(() => {
        // eslint-disable-next-line no-use-before-define
        const box = boxRef.current;
        // istanbul ignore next
        if (!box) {
            return;
        }
        setIsOverflow(box.clientWidth < box.scrollWidth);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const [boxMounted, boxRef] = useDOM((ref) => {
        if (window.ResizeObserver) {
            const resizeObserver = new window.ResizeObserver(recalculateWidth);
            resizeObserver.observe(ref);
            recalculateWidth();
            return () => {
                resizeObserver.disconnect();
            };
        }
        return undefined;
    }, [recalculateWidth]);
    useEffect(() => {
        onMounted?.({
            isOverflow,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOverflow]);
    return (React.createElement(React.Fragment, null, React.createElement(component, otherProps, React.createElement(Box, { sx: {
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            display: 'inline-block',
            verticalAlign: 'top',
            maxWidth: '100%',
        }, ref: boxMounted }, children))));
};
